import React from 'react'
import "./Gif.css"

const  Gif = () => {
  return (
   <div className='gif-container'>
        <h1 className='section-heading'>Loading...</h1>
   </div>
  )
}

export  { Gif}